import { Avatar, Box, HStack, Heading, IconButton, Input, Spacer, Spinner, Text, VStack } from '@chakra-ui/react';
import { useMemo, useRef } from 'react';
import { useProfile } from '../../../../../packages/ui/contexts/ProfileProvider';
import { useTheme } from '../../../../../packages/ui/contexts/ThemeProvider';
import { badges } from '../../pages/Profile/components/Plans';
import { FaPencilAlt } from 'react-icons/fa';

export function ProfileCard() {
  const { profile, updateProfileImage, isLoading } = useProfile();
  const { name, getValidSubscriptions, bookstoreLabels, colors } = useTheme();
  const activeSubscriptions = useMemo(() => getValidSubscriptions(profile), [profile, getValidSubscriptions]);

  const inputRef = useRef<HTMLInputElement | null>(null);

  if (!profile) return <></>;

  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      updateProfileImage(file);
    }
  };

  return (
    <VStack color="white" padding="20px" width="100%" backgroundColor={'primaryColor'} borderRadius={'20px'}>
      <HStack align={'flex-start'} w={'100%'} justify={'space-between'}>
        <VStack spacing={1} align={'flex-start'}>
          <Heading fontFamily={'Montserrat'} fontSize={'21px'}>
            Olá, {profile.fullName}
          </Heading>
          {activeSubscriptions.length > 0 && <Text fontSize={'14px'}>Cliente {name}</Text>}
        </VStack>

        <Box position={'relative'} backgroundColor={'white'} borderRadius={'100px'} padding="3px">
          {profile.image ? (
            <Avatar src={profile.image} size="lg" />
          ) : (
            <Box
              width="64px"
              height="64px"
              backgroundColor={'#F5F5F5'}
              display="flex"
              justifyContent="center"
              alignItems="center"
              borderRadius={100}
            >
              <Text
                align={'center'}
                textTransform={'capitalize'}
                fontWeight={'bold'}
                fontSize={'30px'}
                color={colors.primaryColor}
              >
                {profile.fullName.charAt(0)}
              </Text>
            </Box>
          )}
          <Box position="absolute" bottom="-10px" right="-5px">
            {isLoading ? (
              <Spinner color={colors.primaryColor} />
            ) : (
              <IconButton
                icon={<FaPencilAlt color={colors.primaryColor} />}
                size="sm"
                aria-label="Edit profile picture"
                onClick={() => inputRef.current?.click()}
              />
            )}
            <Input type="file" accept="image/*" ref={inputRef} display="none" onChange={handleImageChange} />
          </Box>
        </Box>
      </HStack>
      <HStack paddingTop={'20px'} paddingRight={'10px'} width={'100%'}>
        <Text fontSize={'14px'}>
          <b style={{ fontSize: '18px' }}>{profile.econometer.books}</b> {bookstoreLabels.plural} adquirid
          {bookstoreLabels.prefixPlural}
        </Text>
        <Spacer />
        <VStack gap={0} align={'flex-end'}>
          <HStack>
            {activeSubscriptions.length > 0 &&
              badges.find((b) => b.level === activeSubscriptions[0].plan.level)?.image && (
                <img
                  src={`/${badges.find((b) => b.level === activeSubscriptions[0].plan.level)?.image}`}
                  width={'20px'}
                />
              )}
            {activeSubscriptions.length > 0 && (
              <Heading fontSize={'18px'} fontWeight={600}>
                {activeSubscriptions[0].plan.name}
              </Heading>
            )}
          </HStack>
          {activeSubscriptions.length > 0 && (
            <Text fontWeight={600} fontSize={'14px'}>
              R$ {activeSubscriptions[0].plan.value.replace('.', ',')}
            </Text>
          )}
        </VStack>
      </HStack>
    </VStack>
  );
}
